import {Component, inject, Inject, OnDestroy, OnInit, signal} from '@angular/core';
import {SessionStoreDataService} from '../../../projects/products-lib/src/lib/services/session-store-data.service';
import {AccountHeaderComponent} from '../account-header-component/account-header-component';
import {ENV_TOKEN, EnvInterface} from 'env-config';
import {ExternalRedirect} from '../../../projects/auth/src/lib/services/external-redirect.service';
import {HeaderParamsService} from '../../services/header-params.service';
import {PupilMemberService} from '../../services/pupil-member.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, Subscription} from 'rxjs';

@Component({
  selector: 'app-header',
  imports: [
    AccountHeaderComponent,
  ],
  templateUrl: './header-component.html',
  styleUrl: './header-component.sass',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private readonly infoRoutes = ['/privacy', '/cookies'];

  isLoggedIn;
  showHeaderTitle = signal(true);
  showHeaderTitleElevenPlus = signal(true);
  showHeaderTitleProductSelector = signal(false);
  logoLink = signal('/online-products');
  readonly pupilMemberService = inject(PupilMemberService);
  private routeSub: Subscription | undefined;
  private storageListener = () => {
    const token = sessionStorage.getItem('authToken');
  };

  constructor(
    @Inject(ENV_TOKEN)
    protected readonly environment: EnvInterface,
    private sessionStoreDataService: SessionStoreDataService,
    protected externalRedirect: ExternalRedirect,
    public headerParamsService: HeaderParamsService,
    private router: Router,
    private route: ActivatedRoute) {
    this.isLoggedIn = this.sessionStoreDataService.isLoggedInSignal;
  }

  ngOnInit(): void {
    window.addEventListener('storage', this.storageListener);
    this.pupilMemberService.loadPupilIcon();
    this.pupilMemberService.loadPupilDisplayName();
    this.updateHeaderTitleVisibility();
    this.routeSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      this.updateHeaderTitleVisibility();
      // Reload pupil data after navigation (e.g. after login redirect to 11+ page)
      if (this.router.url.includes('/11-plus-online-tests')) {
        this.pupilMemberService.loadPupilIcon();
        this.pupilMemberService.loadPupilDisplayName();
        // If we're on this route, we want to show the profile, it should always be available
        // but worth showing us if it's not
        this.headerParamsService.setShowProfileInfo(true);
      }
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('storage', this.storageListener);
    this.routeSub?.unsubscribe();
  }

  pupilIconAltText(url: string): string {
    let fileName = url.split('/').pop() || '';
    fileName = fileName.split('?')[0]; // Remove query string if present
    fileName = fileName.split('.')[0]; // Remove file extension if present
    return `Pupil Icon: ${fileName}`;
  }

  private updateHeaderTitleVisibility(): void {
    const currentUrl = this.router.url;
    const isInfoPage = this.infoRoutes.some(r => currentUrl === r || currentUrl.startsWith(r + '?'));
    if (isInfoPage) {
      this.showHeaderTitle.set(false);
      this.showHeaderTitleElevenPlus.set(false);
      return;
    }

    let currentRoute = this.route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    const routeContext = currentRoute.snapshot.data['routeContext'] || '';
    console.log(`** routeContext: ${JSON.stringify(routeContext)}`);
    const isProductSelector = routeContext === 'product-selector';
    this.showHeaderTitleProductSelector.set(isProductSelector);
    this.showHeaderTitle.set(!isProductSelector && routeContext !== '11-plus-online-tests' && routeContext !== 'eleven-plus');
    this.showHeaderTitleElevenPlus.set(routeContext === 'eleven-plus');

    let logoUrl = isProductSelector ? '/product-selector' : (routeContext !== 'eleven-plus' ? '/revision-hub' : '/11-plus-online-tests');

    if (logoUrl === '/11-plus-online-tests') {
      const pid = currentRoute.snapshot.queryParamMap.get('pid');
      if (pid) {
        logoUrl += `?pid=${pid}`;
      }
    }
    this.logoLink.set(logoUrl);
  }

  logout() {
    this.sessionStoreDataService.removeStoredData('authToken');
    sessionStorage.removeItem('productSelected');
  }
}
